// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"Custom_visuallyHidden__JEvxE"};